import { render, staticRenderFns } from "./ResearchView.vue?vue&type=template&id=084af7f4&scoped=true&"
import script from "./ResearchView.vue?vue&type=script&lang=js&"
export * from "./ResearchView.vue?vue&type=script&lang=js&"
import style0 from "./ResearchView.vue?vue&type=style&index=0&id=084af7f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084af7f4",
  null
  
)

export default component.exports